




























































































































import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';
import {getModule} from 'vuex-module-decorators';
import '@/packages/flag-icon-css/flags.scss';

import {LoriotNetworkServer} from '@/model/lora/LoriotNetworkServer';

import {ILoraForwarderLoriotService} from '@/services/lora/forwarder/ILoraForwarderLoriot.service';

import LoraForwarderLoriotStore from '@/store/lora/LoraForwarderLoriot.store';

import LoraForwarderControl from '@/components/Lora/Forwarder/LoraForwarderControl.vue';
import LoraForwarderLog from '@/components/Lora/Forwarder/LoraForwarderLog.vue';
import {Notify} from '@/utils/Notify';

enum NetworkConfigMode {
  Auto,
  Manual,
  Custom,
}

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {LoraForwarderLog, LoraForwarderControl},
})
export default class LoraForwarderLoriotSettings extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ILoraForwarderLoriotService'))
  private loraForwarderLoriotService!: ILoraForwarderLoriotService;

  private forwarderStore: LoraForwarderLoriotStore = getModule(LoraForwarderLoriotStore, this.$store);

  private saving = false;

  private networkServerAddress: string = '';

  private networkServerCustomAddress: string = '';
  private networkServerCustomPort: string = '';
  private certificate!: File;

  private networkConfig: NetworkConfigMode = NetworkConfigMode.Auto;
  private NetworkConfigMode = NetworkConfigMode;

  private networkServers: LoriotNetworkServer[] | any = [
    {
      header: 'Europe & africa',
    },
    {
      url: 'eu1.loriot.io',
      label: 'EU1',
      location: 'Frankfurt, Germany',
      flag: 'de',
    },
    {
      url: 'eu2.loriot.io',
      label: 'EU2',
      location: 'Amsterdam, Netherlands',
      flag: 'nl',
    },
    {
      url: 'eu3.loriot.io',
      label: 'EU3',
      location: 'Madrid, Spain',
      flag: 'es',
    },
    {
      url: 'uk1.loriot.io',
      label: 'UK1',
      location: 'London, United Kingdom',
      flag: 'gb',
    },
    {
      url: 'af1.loriot.io',
      label: 'AF1',
      location: 'Cape Town, South Africa',
      flag: 'za',
    },
    {
      divider: true,
    },
    {
      header: 'Asia & pacific',
    },
    {
      url: 'ap1.loriot.io',
      label: 'AP1',
      location: 'Singapore',
      flag: 'sg',
    },
    {
      url: 'au1.loriot.io',
      label: 'AU1',
      location: 'Sydney, Australia',
      flag: 'au',
    },
    {
      url: 'cn1.loriot.io',
      label: 'CN1',
      location: 'Shenzhen, China',
      flag: 'cn',
    },
    {
      url: 'ap2.loriot.io',
      label: 'AP2',
      location: 'Tokyo, Japan',
      flag: 'jp',
    },
    {
      url: 'ap3.loriot.io',
      label: 'AP3',
      location: 'Mumbai, India',
      flag: 'in',
    },
    {
      divider: true,
    },
    {
      header: 'Americas',
    },
    {
      url: 'us1.loriot.io',
      label: 'US1',
      location: 'California, USA',
      flag: 'us',
      region: 'americas',
    },
    {
      url: 'us2.loriot.io',
      label: 'US2',
      location: 'New York, USA',
      flag: 'us',
      region: 'americas',
    },
    {
      url: 'sa1.loriot.io',
      label: 'SA1',
      location: 'Sao Paulo, Brazil',
      flag: 'br',
      region: 'americas',
    },
  ];

  private async mounted() {
    await this.refresh();
    this.setLoaded();
  }

  private async refresh() {
    try {
      const networkServerAddress = await this.loraForwarderLoriotService.getNetworkServerAddress();

      if (networkServerAddress === '') {
        this.networkConfig = NetworkConfigMode.Auto;
        this.networkServerAddress = networkServerAddress;
      } else {
        this.networkConfig = NetworkConfigMode.Custom;

        for (const server of this.networkServers) {
          if (server.url === networkServerAddress) {
            this.networkConfig = NetworkConfigMode.Manual;
            this.networkServerAddress = networkServerAddress;
            break;
          }
        }

        if (this.networkConfig === NetworkConfigMode.Custom) {
          this.networkServerCustomAddress = networkServerAddress;
          this.networkServerCustomPort = await this.loraForwarderLoriotService.getNetworkServerPort();
        }
      }

    } catch (error) {
      Notify.Error(this.logger, `Could not get network server`, error);
    }
  }

  private async save() {
    this.saving = true;
    try {

      switch (this.networkConfig) {
        case NetworkConfigMode.Auto:
          await this.loraForwarderLoriotService.setNetworkServerAddress('');
          await this.loraForwarderLoriotService.setNetworkServerPort('');
          break;

        case NetworkConfigMode.Manual:
          await this.loraForwarderLoriotService.setNetworkServerAddress(this.networkServerAddress);
          await this.loraForwarderLoriotService.setNetworkServerPort('');
          break;

        case NetworkConfigMode.Custom:
          await this.loraForwarderLoriotService.setNetworkServerAddress(this.networkServerCustomAddress);
          await this.loraForwarderLoriotService.setNetworkServerPort(this.networkServerCustomPort);
          break;
      }

    } catch (error) {
      Notify.Error(this.logger, `Could not save network server`, error);
    } finally {
      this.saving = false;
    }
  }
}

